export const APP_ENV = process.env.REACT_APP_ENV;
export const AUTH0_SCOPES = 'user_metadata openId read:all';